import React from 'react';
import DiscoveryTooltip from '../DiscoveryTooltip';
import { NavLink, useLocation } from 'react-router-dom';
import { logout } from '../Auth';

/**
 * One sidebar item. A real link (<a href>) so the keyboard can reach it, Enter follows it,
 * screen readers announce the current page (aria-current) and the browser offers "open in
 * new tab". The selection rule is unchanged from the old click-only div: `exactPath` matches
 * the pathname exactly, otherwise any pathname containing `path` selects the item, and the
 * `home` item is also selected on '/'.
 *
 * `collapsed` hides the label visually (icon rail) but keeps it in the DOM for assistive tech;
 * the tooltip then carries the item name so the rail stays self-explanatory.
 */
const NavigationTab = ({ icon: Icon, tooltip, path, text, home, disabled, exactPath, level = 0, testId, collapsed }) => {
  const { pathname } = useLocation();

  const currentPath = exactPath ? pathname === path : pathname.includes(path);
  const selected = home ? pathname === '/' || currentPath : currentPath;

  return (
    <DiscoveryTooltip placement='right' text={collapsed ? text : tooltip}>
      <NavLink
        to={path}
        isActive={() => selected}
        activeClassName='navigation-tab-selected'
        className={'navigation-tab' + (disabled ? ' disabled' : '')}
        aria-disabled={disabled ? 'true' : undefined}
        tabIndex={disabled ? -1 : undefined}
        onClick={disabled ? (e) => e.preventDefault() : undefined}
        style={{ marginLeft: collapsed ? 0 : level * 20 }}
        data-testid={testId}
      >
        <span className='navigation-tab__row'>
          <Icon className='navigation-tab__icon' aria-hidden='true' />
          <span className={'navigation-tab__label' + (collapsed ? ' sr-only' : '')}>{text}</span>
        </span>
      </NavLink>
    </DiscoveryTooltip>
  );
};

const LogoutTab = ({ icon: Icon, text, tooltip, collapsed }) => {
  return (
    <DiscoveryTooltip placement='right' text={collapsed ? text : tooltip}>
      <button
        type='button'
        className='navigation-tab navigation-tab--button'
        data-testid='nav-logout'
        onClick={async () => {
          await logout();
          // replace() rather than reload(): reload() re-renders the SAME url, so logging out
          // of /advanced-config left that page as the current history entry to walk back
          // into (C2D-1198). Landing on the root puts the login screen there instead.
          window.location.replace('/');
        }}
      >
        <span className='navigation-tab__row'>
          <Icon className='navigation-tab__icon' aria-hidden='true' />
          <span className={'navigation-tab__label' + (collapsed ? ' sr-only' : '')}>{text}</span>
        </span>
      </button>
    </DiscoveryTooltip>
  );
};

export {
  NavigationTab,
  LogoutTab
}
